<template>
  <div>
    <v-row class="field-indent">
      <div v-if="select.placeholder" class="description">{{ description }}</div>
      <ValidationProvider name="gender" slim  :rules="rules" v-slot="{ errors }" >
        <v-radio-group v-model="selection" row :error-messages="errors[0]">
          <template v-for="choice in select.metadata.choices" >
            <v-radio color="primary" :label="`${$t(choice.text)}`" :value="`${choice.value}`" :key="choice.key"></v-radio>
          </template>
        </v-radio-group>
      </ValidationProvider>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'RadioSelectField',
    props: ['select'],
    data: () => ({
      selection: ''
    }),
    computed: {
      requiredHint() {
        return this.select.required ? ' *' : '';
      },
      rules() {
        return this.select.required ? 'required' : ''
      },
      description() {
        return `${this.$t(this.select.placeholder)} ${this.requiredHint}`;
      }
    },
    watch: {
      selection() {
        this.$emit('setSelect', {key: this.select.key, value: this.selection})
      }
    }
  }
</script>

<style scoped>
  .v-row {
    flex-wrap: wrap;
  }
  .description {
    width: 100%;
  }
</style>
